import {
  UploadStatusEnum,
  UserStatusEnum,
} from "@/definitions/enums"

export const statusConfig: Record<
  UploadStatusEnum,
  { color: string; text: string }
> = {
  [UploadStatusEnum.PROCESSED]: {
    color: "bg-green-500 hover:bg-green-600",
    text: "Processado",
  },
  [UploadStatusEnum.PROCESSING]: {
    color: "bg-yellow-500 hover:bg-yellow-600",
    text: "Processando",
  },
  [UploadStatusEnum.FAILED]: {
    color: "bg-red-500 hover:bg-red-600",
    text: "Falhou",
  },
  [UploadStatusEnum.UPLOADED]: {
    color: "bg-blue-500 hover:bg-blue-600",
    text: "Enviado",
  },

  [UploadStatusEnum.ERROR]: {
    color: "bg-red-500 hover:bg-red-600",
    text: "Erro",
  },
  [UploadStatusEnum.CREATED]: {
    color: "bg-blue-500 hover:bg-blue-600",
    text: "Criado",
  },
  [UploadStatusEnum.CONVERSION_FAILED]: {
    color: "bg-rose-500 hover:bg-rose-600",
    text: "Conversão falhou",
  },
  [UploadStatusEnum.CONVERTED]: {
    color: "bg-green-500 hover:bg-green-600",
    text: "Conversão realizada",
  },
  [UploadStatusEnum.VALIDATING]: {
    color: "bg-gray-500 hover:bg-gray-600",
    text: "Validação pendente",
  },
  [UploadStatusEnum.VALIDATE_ERROR]: {
    color: "bg-rose-500 hover:bg-rose-600",
    text: "Validação falhou",
  },
  [UploadStatusEnum.VALIDATED]: {
    color: "bg-green-500 hover:bg-green-600",
    text: "Validação realizada",
  },
  [UploadStatusEnum.SKIPPED]: {
    color: "bg-gray-500 hover:bg-gray-600",
    text: "Pulado",
  },
  [UploadStatusEnum.ALL]: {
    color: "bg-gray-500 hover:bg-gray-600",
    text: "Todos",
  },
  [UploadStatusEnum.DELETED]: {
    color: "bg-rose-500 hover:bg-rose-600",
    text: "Apagado",
  },
}

export const usersStatusConfig: Record<
  string,
  { color: string; text: string }
> = {
  [UserStatusEnum.ACTIVE]: {
    color: "bg-blue-500 hover:bg-blue-600",
    text: "Ativo",
  },
  [UserStatusEnum.INACTIVE]: {
    color: "bg-red-500 hover:bg-red-600",
    text: "Inativo",
  },
}
